export class Settings {
    constructor(public name: string, 
                public apiURL: string,) { }

                
}